import Checkbox from './Checkbox';
import Content from './Content';
import Date from './Date';
import Items from './Items';
import LongAnswer from './LongAnswer';
import Number from './Number';
import Radio from './Radio';
import Select from './Select';
import ShortAnswer from './ShortAnswer';
import Upload from './Upload';
import {FieldType} from '../models/JsonTypes';

const map: { [key in FieldType]: any } = {
    'checkbox': Checkbox,
    'content': Content,
    'date': Date,
    'items': Items,
    'long': LongAnswer,
    'number': Number,
    'radio': Radio,
    'select': Select,
    'short': ShortAnswer,
    'upload': Upload,
};

export default map;
